import { TextWordType } from "@model";

export function getTagType(tag: string): TextWordType {
  const arr = tag.split("__");
  const type = arr.at(0) || "";

  if (type === "n") {
    return TextWordType.NOUN;
  }
  if (type === "v") {
    return TextWordType.VERB;
  }
  return TextWordType.NOUN;
}

export function getLemma(tag: string): string {
  function fallback() {
    console.log('!!!! problem with lemma')
    return ""
  }
  const arr = tag.split("__");
  return arr[2]?.split("_")[0] || fallback();
}
